import React from 'react'
import { useState } from 'react'
import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, useTheme } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import FilterAltIcon from '@mui/icons-material/FilterAlt'

import moment from 'moment';
import { navigation2, sortTableData } from '../../../../common/helper';
import { useEffect } from 'react';
import { useTranslation } from '../../../../../i18n/I18nProvider'
const WeightChrgTable = (props) => {
    const { modalId, updateModal, reportData } = props
    const { translations } = useTranslation()
    const gs = translations?.generalSettings || {}
    const tr = (key, fallback) => gs?.[key] || fallback
    const [tableData, setTableData] = useState([])
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("");
    const columnDefs = [
        { headerName: tr('gsSN', 'SN'), headerSx: { textAlign: 'right', minWidth: "40px" }, field: "SN", dataType: "string", showfilter: false, allowSorting: false },
        { headerName: tr('gsCnsType', 'Consignment Type'), headerSx: { textAlign: 'left', minWidth: "200px" }, field: "ConsignmentType", dataType: "string", showfilter: true, allowSorting: false },
        { headerName: tr('fromNop', 'From NOP'), headerSx: { textAlign: 'right', minWidth: "140px" }, field: "FromNOP", dataType: "string", showfilter: false, allowSorting: false },
        { headerName: tr('toNop', 'To NOP'), headerSx: { textAlign: 'right', minWidth: "140px" }, field: "ToNOP", dataType: "string", showfilter: false, allowSorting: false },
        { headerName: tr('weightCharge', 'Weight Charge'), headerSx: { textAlign: 'right', minWidth: "140px" }, field: "MinimumWeightCharge", dataType: "string", showfilter: false, allowSorting: false },
        { headerName: tr('gsModBy', 'Modified By'), headerSx: { textAlign: 'left', minWidth: "140px" }, field: "UserModiFied", dataType: "string", showfilter: false, allowSorting: true },
        { headerName: tr('gsModDt', 'Modified Date & Time'), headerSx: { textAlign: 'left', minWidth: "180px" }, field: "LastUpdatedDate", dataType: "time", showfilter: false, allowSorting: true },
        { headerName: tr('gsActive', 'Active'), headerSx: { textAlign: 'left', minWidth: "100px" }, field: "IsActive", dataType: "string", showfilter: false, allowSorting: false },
    ]
    useEffect(() => {
        setTableData(reportData.sort((a, b) => a.ConsignmentType.localeCompare(b.ConsignmentType)))
    }, [reportData])
    const sortTable = (e, field, sortOrder, type) => {
        e.stopPropagation();
        setOrder(sortOrder);
        setOrderBy(field);
        const sortedData = sortTableData(e, field, sortOrder, type, tableData.map((val) => ({ ...val, "LastUpdatedDate": val.LastUpdatedDate.replace(",", '') })))
        setTableData(sortedData);
    }
    const handleSearchData = (event) => {
        let filterData = reportData.filter((val) => (event.target.value === "" || val.ConsignmentType.toLowerCase().includes(event.target.value.toLowerCase())))
        setTableData(filterData)
    }
    return (
        <TableContainer component={Paper} className='scrollBlue' sx={{ maxHeight: '60vh', marginBottom: "5px" }} >
            <Table stickyHeader size="small" aria-label="a dense table">
                <TableHead sx={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                    <TableRow>
                        {columnDefs.map((col, index) =>
                            <TableCell key={`TH-${index}`} sx={{ ...col.headerSx, backgroundColor: '#DAEDFE', minHeight: '40px', fontSize: '12px', fontWeight: '600', color: '#444' }}>
                                {col.allowSorting ?

                                    <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                        <span>{col.headerName}</span>
                                        <span className='SortingIcons'>
                                            <span
                                                className={`up ${(orderBy === col.field && order === 'asc') ? 'active' : ''}`}
                                                onClick={(e) => sortTable(e, col.field, "asc", col.dataType)}
                                            >
                                                <FontAwesomeIcon icon={faCaretUp} transform="shrink-2" />
                                            </span>
                                            <span
                                                className={`down ${(orderBy === col.field && order === 'desc') ? 'active' : ''}`}
                                                onClick={(e) => sortTable(e, col.field, "desc", col.dataType)}
                                            >
                                                <FontAwesomeIcon icon={faCaretDown} transform="shrink-2" />
                                            </span>
                                        </span>
                                    </div>
                                    :
                                    <span>{col.headerName}</span>

                                }
                            </TableCell>
                        )}
                    </TableRow>
                    <TableRow>
                        {columnDefs.map((col, index) => col.showfilter ?
                            <TableCell key={`FTH-${index}`} sx={{ minHeight: '36px' }}>
                                <div className="filter-input" style={{ fontSize: '10px', justifyContent: 'space-between' }}>
                                    <input
                                        id={`filter-${index}`}
                                        className="field"
                                        name="cancelSearchInput"
                                        style={{ width: '100%' }}
                                        placeholder={tr('gsContains', 'Contains')}
                                        onKeyDown={(e) => {
                                            navigation2(e, "Select_Consignment_Type", "editExisting")
                                        }}
                                        onChange={(event) => handleSearchData(event)}

                                    />
                                    <FilterAltIcon sx={{ paddingRight: '0px !important', color: '#aaa !important' }} />
                                </div>
                            </TableCell>
                            : <TableCell></TableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tableData.length > 0 ? tableData.map((val, index) =>
                        <TableRow key={`DR-${index}`}>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{index + 1}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', }}>{val.ConsignmentType}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{val.FromNOP}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{val.ToNOP}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{val.MinimumWeightCharge}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '140px' }}>
                                <Tooltip title={`${val.UserModiFied}(${val.UserBranch})`}
                                    PopperProps={{
                                        sx: {
                                            "& .MuiTooltip-tooltip": {
                                                backgroundColor: '#DAEDFE',
                                                color: "#000",
                                                minHeight: '26px',
                                                display: 'flex',
                                                fontWeight: '400',
                                                alignItems: "center",
                                                marginTop: '5px !important',
                                                fontSize: '12px'
                                            }
                                        }
                                    }}
                                    placement="bottom-start">
                                    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: "underline" }}
                                        onMouseOut={(e) => e.currentTarget.style.color = '#444'}
                                        onMouseOver={(e) => e.currentTarget.style.color = '#0086FF'}
                                    >
                                        {val.UserModiFied}
                                    </span>
                                </Tooltip>
                            </TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', }}>{moment(val.LastUpdatedDate).format("HH:mm, DD-MMM-YY")}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666' }}>
                                <Checkbox
                                    checked={val.IsActive === 1}
                                    sx={{ padding: 0, }}
                                />
                            </TableCell>

                        </TableRow>
                    ) : <TableRow>
                        <TableCell colSpan={columnDefs.length} sx={{ minHeight: '36px', textAlign: 'center', fontSize: '12px', color: '#666', fontWeight: 600 }}>{tr('gsNoRecord', 'No Record')}</TableCell>
                    </TableRow>}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default WeightChrgTable
